import script from "./MobileDownload.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileDownload.vue?vue&type=script&setup=true&lang=ts"

import "./MobileDownload.vue?vue&type=style&index=0&id=35a1aa8f&scoped=true&lang=css"

import exportComponent from "/Users/jdmacminim61/Workspace/golfourit_ec_system/ec-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a1aa8f"]])

export default __exports__